<template>
    <div>
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header" :header-title="$t('request_withdraw')"></page-header>
        <point-withdraw-component :point-type="'pointWithdraw'"></point-withdraw-component>
    </div>
</template>

<script>

import MyPageHeaderComponent from "@/components/mypage/MyPageHeaderComponent";
import PointWithdrawComponent from "@/components/point/PointWithdrawComponent";

export default {
    name: "PointWithdraw",
    mixins: [],
    components: {PointWithdrawComponent, MyPageHeaderComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tab: 'pointWithdraw',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        movePage(url) {
            this.$router.push(url);
        },
        changeTab(tab) {
            this.tab = '';
            this.$nextTick(() => {
                this.tab = tab
            })
            // this.$router.replace(`${this.$route.path}?tab=${tab}`);
            this.movePage(`/mypage/point/${tab}`);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
